import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M10.427 2.349c1.165-1.944 3.981-1.944 5.146 0l.706 1.178a1 1 0 0 0 1.1.456l1.333-.334c2.198-.551 4.19 1.44 3.64 3.64l-.335 1.33a1 1 0 0 0 .456 1.102l1.178.706c1.944 1.165 1.944 3.981 0 5.146l-1.178.706a1 1 0 0 0-.456 1.1l.334 1.333c.55 2.198-1.44 4.19-3.64 3.639l-1.331-.334a1 1 0 0 0-1.1.456l-.707 1.178c-1.165 1.944-3.982 1.944-5.146 0l-.706-1.178a1 1 0 0 0-1.101-.456l-.243-.97.243.97-1.332.334c-2.198.55-4.19-1.441-3.64-3.64l.335-1.331a1 1 0 0 0-.456-1.101l-1.178-.706c-1.944-1.165-1.944-3.982 0-5.146l1.178-.706a1 1 0 0 0 .456-1.101l-.334-1.332c-.551-2.198 1.44-4.19 3.64-3.64l1.331.335a1 1 0 0 0 1.1-.456l.707-1.178Zm3.43 1.028a1 1 0 0 0-1.715 0l-.706 1.178a3 3 0 0 1-3.302 1.368l-1.332-.334a1 1 0 0 0-1.213 1.213l.334 1.332a3 3 0 0 1-1.368 3.302l-1.178.706a1 1 0 0 0 0 1.716l1.178.705a3 3 0 0 1 1.368 3.303l-.334 1.332a1 1 0 0 0 1.213 1.213l.243.97-.243-.97 1.332-.334a3 3 0 0 1 3.302 1.368l.706 1.178a1 1 0 0 0 1.716 0l.705-1.178a3 3 0 0 1 3.303-1.368l1.332.334a1 1 0 0 0 1.213-1.213l-.334-1.332a3 3 0 0 1 1.368-3.303l1.178-.705a1 1 0 0 0 0-1.716l-1.178-.706a3 3 0 0 1-1.368-3.302l.334-1.332a1 1 0 0 0-1.213-1.213l-1.332.334a3 3 0 0 1-3.303-1.368l-.705-1.178ZM13 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
